export type StammdatenHandelsregisterBezeichnungEnum = 'HRA' | 'HRB' | 'GsR' | 'PR' | 'GnR' | 'VR';

export const StammdatenHandelsregisterBezeichnungEnum = {
    HRA: 'HRA' as StammdatenHandelsregisterBezeichnungEnum,
    HRB: 'HRB' as StammdatenHandelsregisterBezeichnungEnum,
    GsR: 'GsR' as StammdatenHandelsregisterBezeichnungEnum,
    PR: 'PR' as StammdatenHandelsregisterBezeichnungEnum,
    GnR: 'GnR' as StammdatenHandelsregisterBezeichnungEnum,
    VR: 'VR' as StammdatenHandelsregisterBezeichnungEnum
};

